// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__pFY0V","icon_wrapper":"styles_icon_wrapper__JYz69","success":"styles_success__vZhME","error":"styles_error__hBN28"};